import getIn from 'transmute/getIn';
import { OWNER_BY_USER_ID } from '../constants/KeyPaths';
export const getOwnerByUserId = getIn(OWNER_BY_USER_ID);